module.exports = __webpack_public_path__ + "img/11.d69e9b87.png";